import http from '@/api/http';
import { serialize } from '@/utils/format';

export async function info(token) {
    try {
        const response = await http.get('api/v3/organization/department/organization',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function getDepartments(token) {
    try {
        const response = await http.get('api/v3/organization/department/info',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function getStatuses(token) {
    try {
        const response = await http.get('api/v3/organization/department/info',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function getPositions(token) {
    try {
        const response = await http.get('api/v3/organization/employee/position',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateDepartment(token, data) {
    try {
        let dataPram = {
            'organization_id': data.organization_id,
            'title': data.title,
            'description': data.description,
            'parent_id': data.parent_id,
            'parent_is_employee': data.parent_is_employee,
            'status_id': data.status_id,
            'department_head': data.department_head
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        const response = await http.post('api/v3/organization/department',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updatePosition(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'description': data.description
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        const response = await http.post('api/v3/organization/employee/position',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateEmployee(token, data) {
    try {
        let dataPram = {
            'parent_id': data.parent_id,
            'department_id': data.department_id,
            'position_id': data.position_id,
            'is_staff': data.is_staff,
            'is_admin': data.is_admin,
            'login': data.login,
            'first_name': data.first_name,
            'last_name': data.last_name,
            'patronymic': data.patronymic,
            'roles_id': data.roles_id,
            'mail': data.mail,
            'phone': data.phone,
            'password': data.password,
            'limit_space_file': data.limit_space_file,
            'avatar': data.avatar
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        const formData = new FormData();

        for (const key in dataPram) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, data[key]);
        }
        }
        const response = await http.post('api/v3/organization/employee/',
            formData,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }    
}

export async function removeEmployeeAvatar(token, id) {
    try {
        const response = await http.delete('api/v3/organization/employee/image?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
} 

export async function regenerateAuthData(token, id) {
    try {
        let dataPram = {
            'id': id
        }

        const response = await http.post('api/v3/organization/employee/pass-email',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
} 